import { MutationTree } from 'vuex';
import { AuthState, initialState as resetState } from './state';
import { AUTH } from './mutation-types';
import LoginResponse from '@/models/LoginResponse';

export const mutations: MutationTree<AuthState> = {
    [AUTH.SET_TOKEN](state, token) {
        state.token = token;
    },
    [AUTH.CLEAR_TOKEN](state) {
        localStorage.removeItem('activeB2cPolicy');
        Object.assign(state, resetState);
    },
    [AUTH.SET_USER_INFORMATIONS](state, userInformations: LoginResponse) {
        state.userInformations = userInformations;
    },
    [AUTH.SET_IS_OLD_LOGIN](state, isOldLogin: boolean) {
        state.isOldLogin = isOldLogin;
    },
    [AUTH.SET_EMAIL_AZURE](state, mail: string) {
        if (!state.userInformations) {
            state.userInformations = {
                aud: '',
                email: '',
                email_azure: mail,
                fonctions: [],
                iat: null,
                isClient: false,
                isFournisseur: false,
                iss: '',
                nom: '',
                prenom: '',
                sub: '',
                t_compte_id: null,
                telephone: '',
            };
        } else {
            state.userInformations.email = mail;
        }
    },
    [AUTH.SET_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
};
